import { authHeader, handleResponse } from '../helpers';
export const FeedbackRptService = {
    fetchFeedbackData,
    ServiceReqData,
    ClosureRequest,
    RejectionRequest,
    fetchGetServiceAgentList
};

function fetchFeedbackData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/GetFeedbackReport`, requestOptions)
        .then(handleResponse);
}

function fetchGetServiceAgentList() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify()
    };

    return fetch(`${process.env.REACT_APP_API_URL}ServiceAgent/AgentList`, requestOptions)
        .then(handleResponse);
}
function ServiceReqData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/GetServiceReport`, requestOptions)
        .then(handleResponse);
}

function ClosureRequest(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/ClosureRequest`, requestOptions)
        .then(handleResponse);
}

function RejectionRequest(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}ProductAuthentication/RejectionRequest`, requestOptions)
        .then(handleResponse);
}
